import React from 'react'

export default ({ children }) => (
  <div style={{ padding: '0 8em' }}>
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/layouts/components/container.js